module.exports = __webpack_public_path__ + "static/media/sign_up_modal_img@2x.e6d683ef.png";